import actions from '../actions';

export const initState = {
  selected_transaction: null,
  transactions: [],
  loading: false
};

export default function transactionReducer(state = initState, action) {
  switch (action.type) {
    case actions.transaction.INIT:
      return { ...initState };
    case actions.transaction.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
